/* Cellform — predictive search (products with image + price, collections, articles, pages). */
(() => {
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-search]');
      if (!this.input || !this.results) return;
      this.cache = new Map();
      this.input.addEventListener('input', window.Cellform.debounce(() => this.onInput(), 250));
      this.input.addEventListener('focus', () => { if (this.input.value.trim().length > 1 && this.results.innerHTML) this.open(); });
      this.addEventListener('keydown', (e) => this.onKey(e));
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) setTimeout(() => this.close(), 120); });
    }
    async onInput() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.close(); return; }
      if (this.controller) this.controller.abort();
      if (this.cache.has(q)) { this.render(this.cache.get(q)); return; }
      this.controller = new AbortController();
      const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
      try {
        const html = await fetch(url, { signal: this.controller.signal }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        this.cache.set(q, section.innerHTML);
        this.render(section.innerHTML);
      } catch (e) { /* aborted */ }
    }
    render(html) {
      this.results.innerHTML = html;
      this.options = [...this.results.querySelectorAll('[role="option"]')];
      this.active = -1;
      const status = this.results.querySelector('[data-predictive-status]');
      if (status) window.Cellform.announce(status.textContent);
      this.open();
    }
    open() { this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }
    onKey(e) {
      if (e.key === 'Escape') { this.close(); this.input.focus(); return; }
      if (!this.options || !this.options.length || this.results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + this.options.length) % this.options.length;
        this.options.forEach((o, i) => o.setAttribute('aria-selected', String(i === this.active)));
        const opt = this.options[this.active];
        this.input.setAttribute('aria-activedescendant', opt.id);
        opt.scrollIntoView({ block: 'nearest' });
      }
      if (e.key === 'Enter' && this.active > -1) {
        const link = this.options[this.active].querySelector('a') || this.options[this.active];
        if (link.href) { e.preventDefault(); window.location = link.href; }
      }
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
})();
